{
  "settings": {
    "audit": {
      "dataSources": "Data Sources",
      "functions": "Functions",
      "generalSettings": "Basic Settings",
      "modules": "Modules",
      "notificationTemplates": "Notification Templates",
      "numbers": "Number of days to keep log",
      "roles": "Roles",
      "tables": "Tables",
      "templates": "Templates",
      "title": "Audit Log",
      "users": "Users"
    },
    "colors": {
      "primary": "Primary Text",
      "primaryBG": "Primary Background",
      "secondary": "Secondary Text",
      "secondaryBG": "Secondary Background",
      "title": "Colours"
    },
    "dashboard": {
      "addKPI": "Add KPI",
      "addWidget": "Add agenda",
      "noKPI": "No KPIs defined",
      "requiredKPI": "KPIs must contain at least one item.",
      "noAgendas": "No agendas defined",
      "requiredAgendas": "Overviews must contain at least one item.",
      "placeholder": "Dashboard settings",
      "title": "Dashboard settings",
      "modules": "Modules",
      "agendas": "Agendas",
      "views": "Views",
      "color": "Color",
      "agendaViewSettings": "Agenda overview settings",
      "kpiSettings": "KPI settings",
      "deleteDashboard": "Delete dashboard",
      "deleteDashboardConfirmationText": "This will delete the current dashboard and all its settings. Are you sure you want to continue?",
      "sourceSelect": "Source",
      "heliosSqlScript": "Helios SQL script",
      "view": "View",
      "link": "Link",
      "linkUrl": "Link URL",
      "linkText": "Link title",
      "heliosDataSource": "Helios data source",
      "heliosScript": "Helios script",
      "itemsSettingRequired": "All items must be set",
      "dashboardDataError": "Error loading dashboard data",
      "agendaView": "Agenda overview",
      "kpiItem": "KPI",
      "notification": "Unread information",
      "notificationWithAction": "Pending tasks",
      "groupByModule": "Group by module",
      "showRecordCount": "Show record count"
    },
    "email": {
      "placeholder": "Write an email",
      "text": "Email",
      "title": "Email for bug reports",
      "required": "Email is required",
      "invalid": "Email is invalid"
    },
    "contactEmail": {
      "invalid": "Email is invalid"
    },
    "date": {
      "from": "Valid From is required",
      "to": "Valid To is required",
      "minDate": "Valid To must be greater than Valid From",
      "today": "Valid To must be after today"
    },
    "error": {
      "loginRequired": "Only one can be selected"
    },
    "login": {
      "google": "Google Login",
      "microsoft": "Microsoft Login",
      "keycloak": "Keycloak Login",
      "title": "Login method",
      "warning": "You are changing the login method. After saving the changes, it may cause problems to access the application."
    },
    "recordVersioning": {
      "title": "Record version creation",
      "invalidMode": "Select a valid record version creation mode.",
      "options": {
        "AllUpdates": "On every update",
        "UiUpdatesOnly": "Only on direct edits in the user interface",
        "IncreaseVersionOnly": "Only when the Increase Version action runs"
      },
      "descriptions": {
        "AllUpdates": "Save a historical version whenever a record is updated, including changes made by actions and integrations.",
        "UiUpdatesOnly": "Save a historical version when a record is edited directly in the user interface, before subsequent actions run. Changes made by those actions or integrations do not create additional versions.",
        "IncreaseVersionOnly": "Save a new major version of the record's current state only when the Increase Version action runs."
      }
    },
    "recordLock": {
      "title": "Record lock",
      "duration": "Record lock duration (min)",
      "range": "Enter a whole number from 1 to 120 minutes."
    },
    "templates": {
      "text": "Number of records in views",
      "title": "View settings"
    },
    "user": {
      "profile": "Profile",
      "pageSize": {
        "title": "View settings",
        "label": "Number of records in views"
      },
      "fastSignIn": {
        "title": "Fast sign in",
        "recommended": "Recommended",
        "changePin": "Change PIN code",
        "pin": {
          "title": "PIN code",
          "subtitle": "6-digit PIN – fast and secure"
        },
        "biometry": {
          "title": "Face ID",
          "subtitle": "Sign in with a look – instant"
        },
        "fingerprint": {
          "title": "Fingerprint",
          "subtitle": "Sign in with your fingerprint – instant"
        },
        "none": {
          "title": "None",
          "subtitle": "Do not use fast sign in"
        },
        "actionRequired": {
          "title": "Action required",
          "body": "Set up a fast sign-in method. You can keep using the app without being blocked."
        },
        "confirmNone": {
          "title": "Disable fast sign in?",
          "body": "Are you sure you want to turn off fast sign in? You will no longer be able to unlock the app with PIN or biometrics."
        }
      }
    },
    "contacts": {
      "showContacts": "Show Distribution list",
      "title": "Distribution list"
    }
  },
  "users": {
    "adminPermissions": "Administrator Permissions",
    "impersonate": "Impersonate",
    "cancel_impersonate": "Cancel impersonation",
    "cancel_substitution": "Return to my view",
    "currently_substituting": "Currently substituting user:",
    "start_impersonation_error": "Failed to start impersonation",
    "stop_impersonation_error": "Failed to stop impersonation",
    "resetKeycloak": "Reset Keycloak login",
    "resetKeycloakConfirm": "This clears the Keycloak identity bound to this user. The next Keycloak login will bind the user again.",
    "resetKeycloakSuccess": "Keycloak login was reset.",
    "validToBeforeValidFrom": "Validity To must be greater than Validity From"
  },
  "roles": {
    "table": {
      "name": "Role Name"
    },
    "deleteConfirmation": "Are you sure you want to delete the selected roles? This action cannot be undone.",
    "selectByTag": "By groups",
    "selectIndividually": "Individually",
    "tags": {
      "title": "Tags",
      "addTag": "Add or select tag",
      "placeholder": "Type to add a new tag or select existing one"
    }
  },
  "modules": {
    "name": "Name",
    "deleteConfirmation": "Are you sure you want to delete the selected modules? This action cannot be undone.",
    "renameModule": "Rename module",
    "attachModule": "Pin module",
    "dashboardSettings": "Dashboard settings",
    "isChildModule": "Is child module",
    "parentModule": "Parent Module",
    "selectParentModule": "Select parent module"
  },
  "assistants": {
    "addTitle": "Add Assistant",
    "editTitle": "Edit Assistant",
    "search": "Search assistants",
    "labelSection": "Label",
    "descriptionSection": "Description",
    "idSection": "Assistant ID",
    "vsgAssistantId": "VSG Assistant ID",
    "deleteConfirmation": "Are you sure you want to delete this assistant? This action cannot be undone.",
    "description_En": "Description (EN)",
    "description_Sk": "Description (SK)",
    "description_Cs": "Description (CZ)"
  },
  "substitutability": {
    "showToUsers": "Show substitutability option to users",
    "showInSubstituted": "Show in substituted users",
    "options": {
      "visible": "Yes",
      "hidden": "No"
    },
    "listingType": {
      "None": "None",
      "AllUsers": "All users",
      "OneUserRole": "With one same role",
      "AllUserRoles": "With same roles"
    }
  }
}
